import { render } from "./JoinMedusa.vue?vue&type=template&id=8c1e1d5a"
import script from "./JoinMedusa.vue?vue&type=script&lang=js"
export * from "./JoinMedusa.vue?vue&type=script&lang=js"

import "./JoinMedusa.vue?vue&type=style&index=0&id=8c1e1d5a&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__